module.exports = __webpack_public_path__ + "img/311.8507ef71.png";